import graphql__b43bb091e404e5c8565b from "./__generated__/FormComplete_contribution.graphql.js";import { useCallback } from "react";
import { useFragment } from "react-relay";
import { graphql } from "react-relay";
import { useSelector } from "react-redux";
import { defineMessages } from "react-intl";

import Modal from "../Modals/Modal";
import ContributionFormModalTitle from "../Contributions/ContributionFormModalTitle";
import Button from "../Buttons/Button";
import { useNavigateTo, useRoutesContext } from "../Routes/RoutesContext";
import { useFormatMessage } from "../Intl/Context";

const FormComplete = props => {
  const { onClose } = props;
  const lastNonModalLocation = useSelector(
    ({ location }) => location.lastNonModalLocation
  );

  const contribution = useFragment(FormComplete_contribution, props.contribution);
  const { participativeModule } = contribution;
  const { completeMessage, slug: participativeModuleSlug } = participativeModule;

  const t = useFormatMessage();
  const title = t(intlMessages.title);
  const closeLabel = t(intlMessages.close);

  const { pathFor } = useRoutesContext();
  const participativeModulePath =
    props.participativeModulePath ||
    pathFor("participativeModule", { participativeModuleSlug });
  const returnPath = lastNonModalLocation?.pathname || participativeModulePath;

  const breadcrumbs = [
    {
      title: participativeModule.title,
      url: participativeModulePath
    },
    { title }
  ];

  const navigateTo = useNavigateTo();
  const handleClose = useCallback(() => {
    navigateTo(returnPath);
    if (onClose) onClose();
  }, [navigateTo, onClose, returnPath]);

  return (
    <Modal
      breadcrumbs={breadcrumbs}
      className="modal-sm modal-with-actions"
      onRequestClose={handleClose}
    >
      <ContributionFormModalTitle title={title} contribution={contribution} />

      <div
        className="box margin-bottom-xs padding-x-lg padding-y-md"
        dangerouslySetInnerHTML={{
          __html: completeMessage
        }}
      />

      <div className="modal-actions modal-buttons-container">
        <Button
          type="button"
          onClick={handleClose}
          className="btn btn-primary-inverse btn-block-md box-shadow-lg modal-action"
          label={closeLabel}
          iconClassName="icon-suppr"
          iconPosition="after"
          data-contribution-form-close-button
        />
      </div>
    </Modal>
  );
};

const FormComplete_contribution = graphql__b43bb091e404e5c8565b;

export default FormComplete;

const intlMessages = defineMessages({
  title: {
    id: "contribution.complete.title",
    defaultMessage: "Contribuer"
  },
  close: {
    id: "contribution.complete.close",
    defaultMessage: "Fermer"
  }
});
